import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";
import { Link } from "react-router-dom";

function Delivery() {
  return (
    <div className="delivery">
      <Header />
      <main role="main" id="MainContent" tabIndex={-1}>
        <div
          id="shopify-section-template--19428124000330__header_cms_U8tzJd"
          className="shopify-section"
        >
          <div className="page-width relative">
            <img
              src="/img/editorial-shoes/delivery-handoff.png"
              alt="Courier handing a footwear parcel to a customer"
              className="absolute left-0 top-0 w-full h-full -z-1 object-cover"
            />
            <div className="relative pt-19 pb-16 mx-5 lg:mx-20 lg:py-20.5">
              <Link
                to="/"
                className="absolute left-0 top-4 flex items-center gap-2 p2 text-slate capitalize hover:underline md:p4 lg:top-4.5"
                aria-label="Back"
              >
                <svg
                  className=""
                  xmlns="http://www.w3.org/2000/svg"
                  width={6}
                  height={11}
                  viewBox="0 0 6 11"
                  fill="none"
                >
                  <path
                    d="M0.308181 5.59453C0.313452 5.77902 0.381976 5.9477 0.529569 6.08475L4.63054 10.0908C4.7465 10.2068 4.89409 10.2701 5.06804 10.2701C5.41594 10.2701 5.69531 9.99595 5.69531 9.64806C5.69531 9.47938 5.62679 9.31597 5.50555 9.19474L1.81046 5.5998L5.50555 1.99432C5.62152 1.87309 5.69531 1.71495 5.69531 1.541C5.69531 1.19311 5.41594 0.919006 5.06804 0.919006C4.8941 0.919006 4.7465 0.98226 4.63054 1.09823L0.529569 5.10958C0.381976 5.2519 0.308181 5.41004 0.308181 5.59453Z"
                    fill="currentColor"
                  />
                </svg>
                <span>Useful Info</span>
                <span className="sr-only">Back</span>
              </Link>
              <h1 className="heading-2 text-center">Shipping Info</h1>
            </div>
          </div>
        </div>
        <div
          id="shopify-section-template--19428124000330__support_content_yEDKCc"
          className="shopify-section"
        >
          <div className="page-width pt-5 md:pt-6">
            <div className="page-width__inner is-support-page">
              <div className="pt-5 pb-8.5 md:pt-6 md:pb-10 border-b-1 border-b-mist-light">
                <div className="flex justify-between items-center gap-3 border-b-1 border-b-mist-light py-6 md:py-7.5">
                  <h2 className="shrink-0 w-3/5 p2-bold max-w-45 md:max-w-[548px] md:subheading-2-bold ">
                    Standard USPS (estimated delivery in 3-7 business days)
                  </h2>
                  <div className="max-w-100">
                    <p className="p2-bold text-right">£5</p>
                    <p className="p3 text-right mt-2">
                      Free shipping on £75+ orders
                    </p>
                  </div>
                </div>
                <div className="flex justify-between items-center gap-3 border-b-1 border-b-mist-light py-6 md:py-7.5">
                  <h2 className="shrink-0 w-3/5 p2-bold max-w-45 md:max-w-[548px] md:subheading-2-bold ">
                    Expedited UPS (estimated delivery in 2-3 business days)*
                  </h2>
                  <div className="max-w-100">
                    <p className="p2-bold text-right">£20.00</p>
                  </div>
                </div>
                <div className="flex justify-between items-center gap-3 border-b-1 border-b-mist-light py-6 md:py-7.5">
                  <h2 className="shrink-0 w-3/5 p2-bold max-w-45 md:max-w-[548px] md:subheading-2-bold ">
                    Express UPS (estimated delivery in 1-2 business days)*
                  </h2>
                  <div className="max-w-100">
                    <p className="p2-bold text-right">£35.00</p>
                  </div>
                </div>
                <div className="my-3 md:my-10 last:mb-0">
                  <p className="p3">
                    *Expedited &amp; Express orders ship out the following
                    business day, are not shipped or delivered on
                    weekends/holidays or delivered to P.O. Boxes.
                  </p>
                </div>
                <div className="flex flex-col gap-2.5 md:gap-4.5 my-10 last:mb-0">
                  <h2 className="subheading-1-bold">
                    When will my order ship?
                  </h2>
                  <div className="support-content prose">
                    <p>
                      We ship everything within 1-2 business days, depending on
                      how many orders we've gotten. We try to send everything in
                      your order together but occasionally there might be some
                      things that ship separately.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col gap-2.5 md:gap-4.5 my-10 last:mb-0">
                  <h2 className="subheading-1-bold">
                    How does international shipping work?
                  </h2>
                  <div className="support-content prose">
                    <p>
                      We ship almost all over the globe for £15 via USPS and
                      your country's post office. Additional customs fees/taxes
                      may apply depending on your country's regulations, so it's
                      a good idea to check them out before you order. You can
                      expect to get your order in about 10-14 business days due
                      to customs and/or your slow mailperson.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          id="shopify-section-template--19428124000330__contact_us_UjRa9m"
          className="shopify-section"
        >
          <div className="page-width py-7.5 md:pt-10 md:pb-13">
            <div className="page-width__inner is-support-page">
              <div className="empty:hidden flex flex-col gap-2 md:gap-4 mb-7.5 md:mb-10 max-md:px-5">
                <h2 className="heading-3 mx-auto text-center max-w-[270px] md:max-w-[600px]">
                  Still Have Questions? Contact Us.
                </h2>
                <p className="subheading-2 text-center max-w-[644px] mx-auto">
                  Here's how to get in touch. <br /> Answering in real time
                  9am–5pm PT, Monday through Friday.
                </p>
              </div>
              <div className="flex flex-col justify-center gap-y-12 max-md:px-5 md:flex-row md:flex-wrap">
                <a
                  href="mailto:buyer@mvandora.store"
                  className="flex flex-col items-stretch gap-2 shrink-0 w-full cursor-pointer group md:gap-4.5 md:w-1/3 md:px-2.5"
                  aria-label="Email Us"
                >
                  <div className="w-18 h-18 md:w-26.5 md:h-26.5 mx-auto">
                    <picture>
                      <img
                        className="w-full h-full rounded-full group-hover:scale-105 transition-transform duration-300 object-cover"
                        src="/main/delivery-email.svg"
                        sizes="(min-width: 768px) 106px, 72px"
                        width={54}
                        height={54}
                        loading="lazy"
                        fetchpriority="auto"
                        alt=""
                        decoding="async"
                      />
                    </picture>
                  </div>
                  <h3 className="subheading-1-bold text-center break-all">
                    Email Us
                  </h3>
                  <h4 className="subheading-2-bold text-center break-all ">
                    buyer@mvandora.store
                  </h4>
                  <p className="p1 max-w-76 mx-auto text-center">
                    This is the best and fastest way to reach us. Just send us a
                    note and we’ll get back to you within 24 hours.
                  </p>
                </a>
                <a
                  href="tel:844.544.5199"
                  className="flex flex-col items-stretch gap-2 shrink-0 w-full cursor-pointer group md:gap-4.5 md:w-1/3 md:px-2.5"
                  aria-label="Text or Call Us"
                >
                  <div className="w-18 h-18 md:w-26.5 md:h-26.5 mx-auto">
                    <picture>
                      <img
                        className="w-full h-full rounded-full group-hover:scale-105 transition-transform duration-300 object-cover"
                        src="/main/delivery-phone.svg"
                        sizes="(min-width: 768px) 106px, 72px"
                        width={54}
                        height={54}
                        loading="lazy"
                        fetchpriority="auto"
                        alt=""
                        decoding="async"
                      />
                    </picture>
                  </div>
                  <h3 className="subheading-1-bold text-center break-all">
                    Text or Call Us
                  </h3>
                  <h4 className="subheading-2-bold text-center break-all ">
                    844.544.5199
                  </h4>
                  <p className="p1 max-w-76 mx-auto text-center">
                    Wanna talk to a real human? Shoot us a text or give us a
                    call.
                  </p>
                </a>
                <chat-trigger className="flex flex-col items-stretch gap-2 shrink-0 w-full cursor-pointer group md:gap-4.5 md:w-1/3 md:px-2.5">
                  <div className="w-18 h-18 md:w-26.5 md:h-26.5 mx-auto">
                    <picture>
                      <img
                        className="w-full h-full rounded-full group-hover:scale-105 transition-transform duration-300 object-cover"
                        src="/main/delivery-chat.svg"
                        sizes="(min-width: 768px) 106px, 72px"
                        width={54}
                        height={54}
                        loading="lazy"
                        fetchpriority="auto"
                        alt=""
                        decoding="async"
                      />
                    </picture>
                  </div>
                  <h3 className="subheading-1-bold text-center break-all">
                    Chat With Us
                  </h3>
                  <h4 className="subheading-2-bold text-center break-all underline group-hover:text-slate">
                    Start a chat
                  </h4>
                  <p className="p1 max-w-76 mx-auto text-center">
                    You’ve got questions? We’ve got answers. Our bot’s on it.
                    and we’re here if things get sticky.
                  </p>
                </chat-trigger>
              </div>
            </div>
          </div>
        </div>
        <limespot />
      </main>

      <Footer />
    </div>
  );
}

export default Delivery;
